<div class="col-md-12 no-padding animated fadeIn">
  <h3>Opções para para prestação de contas:</h3>
  <hr>
  
  <button class="btn btn-app animated fadeInDown" pTooltip="Análise de contas" tooltipPosition="top" [routerLink]="['analise-contas/repasses']" routerLinkActive="btn-app-active">
    <i class="fas fa-search-dollar"></i> Análise de contas
  </button>
  <!-- Painel da analise: contadores, historico com decurso e checklist (ADR-0010). -->
  <button class="btn btn-app animated fadeInDown" pTooltip="Contadores, histórico do fluxo e checklist"
    tooltipPosition="top" [routerLink]="['analise-contas/painel']" routerLinkActive="btn-app-active">
    <i class="fas fa-tasks"></i> Painel da análise
  </button>


  <button class="btn btn-app animated fadeInDown" pTooltip="Parcial" tooltipPosition="top">
    <i class="fas fa-clipboard-check"></i> Método de seleção
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Parcial" tooltipPosition="top">
    <i class="fas fa-stream"></i> Timeline
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Parcial" tooltipPosition="top">
    <i class="fas fa-edit"></i> Habilitação
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Parcial" tooltipPosition="top">
    <i class="fas fa-exclamation"></i> Pendências
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Parcial" tooltipPosition="top">
    <i class="fas fa-angle-double-down"></i> Exportar
  </button>
  <button class="btn btn-app animated fadeInDown" pTooltip="Exportar documentos" tooltipPosition="top" [routerLink]="['exportar-documentos']" routerLinkActive="btn-app-active">
    <i class="fas fa-file-export"></i> Exportar documentos
  </button>


  

  <div class="col-md-12 no-padding">
    <hr>
  </div>

</div>

<div class="col-md-12">
  <router-outlet></router-outlet>
</div>